// privatokonomi-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'pkn.ctl.avgOne': 'Snitt av inn og ut siste {count} måned',
  'pkn.ctl.avgMany': 'Snitt av inn og ut siste {count} måneder',
  'pkn.ctl.missingIncomeData': 'Mangler inntekts- og forbruksdata',
  'pkn.ctl.title': 'Økonomisk kontroll',
  'pkn.ctl.sub': 'Buffer, månedlig handlingsrom og kvaliteten på datagrunnlaget',
  'pkn.ctl.adjustBuffer': 'Tilpass buffer',
  'pkn.ctl.missingSpendData': 'Mangler forbruksgrunnlag',
  'pkn.ctl.bufferMonths': '{count} måneder med normalt forbruk',
  'pkn.ctl.bufferTarget': 'Buffermål',
  'pkn.ctl.gapRemaining': '{amount} gjenstår',
  'pkn.ctl.targetCovered': 'Målet er dekket',
  'pkn.ctl.leftPerMonth': 'Til overs per måned',
  'pkn.ctl.missingData': 'Mangler data',
  'pkn.ctl.coverageTitle': 'Datadekning og sporbarhet',
  'pkn.ctl.lastUpdated': 'Sist oppdatert {date}',
  'pkn.ctl.coverageCounts': '{accounts} kontoer · {transactions} transaksjoner · {uncategorized} ukategoriserte',
  'pkn.ctl.missingMonths': 'mangler {months}',
  'pkn.ctl.unlinkedImports': '{count} importer uten konto',
  'pkn.ctl.duplicateImports': '{count} mulige duplikatimporter',
  'pkn.ctl.adjustTarget': 'Tilpass buffermål',
  'pkn.ctl.autoHint': 'Automatisk forslag er tre måneder med registrerte utgifter.',
  'pkn.ctl.useAuto': 'Bruk automatisk forslag',
  'pkn.ctl.allTx': 'Alle transaksjoner',
  'pkn.ctl.allTxSub': 'Søk, filtrer, eksporter og åpne en kategori for å rette posteringer',
  'pkn.ctl.exportCsv': 'Eksporter CSV',
  'pkn.ctl.searchTx': 'Søk i transaksjoner',
  'pkn.ctl.type': 'Type',
  'pkn.ctl.allTypes': 'Alle typer',
  'pkn.ctl.expense': 'Utgift',
  'pkn.ctl.debtPayment': 'Gjeldsbetaling',
  'pkn.ctl.transfer': 'Overføring',
  'pkn.ctl.allCategories': 'Alle kategorier',
  'pkn.ctl.noMatch': 'Ingen transaksjoner matcher filtrene.',
  'pkn.ctl.transaction': 'Transaksjon',
  'pkn.ctl.other': 'Annet',
  'pkn.eie.type.cash': 'Kontanter og brukskonto',
  'pkn.eie.type.savings': 'Buffer og sparekonto',
  'pkn.eie.type.fund': 'Fond',
  'pkn.eie.type.shares': 'Aksjer',
  'pkn.eie.type.other-investment': 'Andre investeringer',
  'pkn.eie.type.property': 'Eiendom',
  'pkn.eie.type.vehicle': 'Kjøretøy',
  'pkn.eie.type.collectible': 'Samleobjekter',
  'pkn.eie.type.other': 'Annet',
  'pkn.eie.icon.home': 'Eiendom',
  'pkn.eie.icon.car': 'Kjøretøy',
  'pkn.eie.icon.building': 'Fritidseiendom',
  'pkn.eie.icon.wallet': 'Sparing',
  'pkn.eie.icon.trendUp': 'Fond / aksjer',
  'pkn.eie.icon.sparkle': 'Verdigjenstander',
  'pkn.eie.health.riskLabel': 'Høy risiko',
  'pkn.eie.health.riskNote': 'Verdien ventes å falle raskt',
  'pkn.eie.health.pressLabel': 'Under press',
  'pkn.eie.health.pressNote': 'Vokser saktere enn inflasjonen',
  'pkn.eie.health.strongLabel': 'Sterk investering',
  'pkn.eie.health.strongNote': 'God avkastning over tid',
  'pkn.eie.health.stableLabel': 'Stabil',
  'pkn.eie.health.stableNote': 'Jevn og forutsigbar verdi',
  'pkn.eie.factor.diversification': 'Diversifisering',
  'pkn.eie.factor.diversificationNote': 'Spredning på ulike typer eiendeler',
  'pkn.eie.factor.liquidity': 'Likviditet',
  'pkn.eie.factor.liquidityNote': 'Andel du raskt kan frigjøre til kontanter',
  'pkn.eie.factor.risk': 'Risikonivå',
  'pkn.eie.factor.riskNote': 'Hvor mye ligger i eiendeler som faller raskt',
  'pkn.eie.factor.leverage': 'Gjeldsgrad',
  'pkn.eie.factor.leverageNote': 'Egenkapital sett mot gjeld',
  'pkn.eie.expectedPerMonth': 'forventet per måned',
  'pkn.eie.expectedToChange': 'ventes å endre seg',
  'pkn.eie.perYearWithValue': 'i året. Med en verdi på {value} tilsvarer det omtrent {amount} {kind} hver måned.',
  'pkn.eie.valueFall': 'i verdifall',
  'pkn.eie.valueGrowth': 'i verdivekst',
  'pkn.eie.projectionNote': 'Fremskrivningen under bruker din egen forventning om årlig verdiendring. Plumme henter ennå ikke inn markedsdata for bolig, bruktbil eller fond — når det er på plass, oppdaterer jeg anslaget automatisk.',
  'pkn.eie.fillNameValue': 'Fyll inn navn og verdi',
  'pkn.eie.editAsset': 'Rediger eiendel',
  'pkn.eie.addAsset': 'Legg til eiendel',
  'pkn.eie.fieldName': 'Navn på eiendel',
  'pkn.eie.phName': 'F.eks. Enebolig',
  'pkn.eie.fieldDetail': 'Beskrivelse',
  'pkn.eie.phDetail': 'F.eks. adresse, årsmodell eller tilbyder',
  'pkn.eie.fieldValue': 'Salgsverdi/markedsverdi i dag (kr)',
  'pkn.eie.fieldTaxValue': 'Skattemessig formuesverdi (kr)',
  'pkn.eie.fieldGrowth': 'Forventet verdiendring per år (%)',
  'pkn.eie.phGrowth': 'f.eks. 3,5 eller −12',
  'pkn.eie.assetType': 'Eiendelstype',
  'pkn.eie.pickColor': 'Velg farge {color}',
  'pkn.eie.taxBasis': 'Skattemessig {amount}',
  'pkn.eie.perYearSuffix': '/år',
  'pkn.eie.notRegistered': 'Ikke registrert',
  'pkn.eie.liquidSub': 'Bank/kontanter {cash} · investeringer {investments}',
  'pkn.eie.liquidNote': 'Likvid formue er penger på konto og fond/aksjer som normalt kan selges. Buffervurderingen bruker bare bank og kontanter, fordi investeringer kan svinge i verdi.',
  'pkn.eie.verdict.solid': 'Solid og godt balansert formue',
  'pkn.eie.verdict.healthy': 'Sunn formue med rom for justering',
  'pkn.eie.verdict.rebalance': 'Formuen bør balanseres bedre',
  'pkn.eie.watchMostPrefix': 'Det jeg følger mest med på er',
  'pkn.eie.mostRoom': 'her er det størst rom for å styrke formuen din.',
  'pkn.eie.fineButBetter': 'som er greit, men kan bli enda bedre.',
  'pkn.eie.perMonth': 'per måned',
  'pkn.eie.monthlyForecastNote': 'i måneden. Når markedsdata kobles på, oppdaterer jeg anslaget automatisk mot bolig-, bruktbil- og fondsmarkedet.',
  'pkn.eie.valueToday': 'Verdien i dag er {value}.',
  'pkn.eie.watchClear': 'Ingen av eiendelene dine krever ekstra oppfølging akkurat nå. Alt ser sunt og balansert ut ut fra forutsetningene du har lagt inn.',
  'pkn.eie.fallWarn': 'Verdien ventes å falle {pct} i året.',
  'pkn.eie.slowWarn': 'Vokser saktere enn inflasjonen ({pct} i året).',
  'pkn.eie.monthlyEquiv': 'Det tilsvarer {amount} i måneden.',
  'pkn.eie.empty': 'Ingen eiendeler registrert ennå. Trykk «Legg til eiendel» for å registrere hus, bil, båt, hytte, kunst, sparing, fond med mer.',
  'pkn.fam.fair.even': 'Jevnt fordelt',
  'pkn.fam.fair.slightly': 'Litt skjevt',
  'pkn.fam.fair.uneven': 'Skjevt',
  'pkn.fam.needTwo': 'Legg inn minst to personer med inntekt og andel felleskostnader, så sammenligner jeg fordelingen mot inntektsandelen.',
  'pkn.fam.perMonthShort': '/ mnd',
  'pkn.fam.ofSharedCosts': '{pct} % av felleskostnadene',
  'pkn.fam.ofIncome': '{pct} % av inntekten',
  'pkn.fam.evenSuffix': 'i felleskostnader hver måned, og hver av dere dekker omtrent den andelen som inntekten tilsier.',
  'pkn.fam.uneven': 'dekker {costShare} % av felleskostnadene, men står for {incomeShare} % av inntekten. En fordeling etter inntekt ville gitt {amount} i måneden — det er {diff} {direction} enn i dag. Hva som er riktig avgjør dere selv; dette er bare regnestykket.',
  'pkn.fam.less': 'mindre',
  'pkn.fam.more': 'mer',
  'pkn.fam.idea.bufferTitle': 'Bygg et felles bufferfond',
  'pkn.fam.idea.bufferText': 'Etter felleskostnader har husholdningen {left} igjen hver måned. Setter dere av 10 % av dette — {monthly} i måneden — har dere {yearly} i buffer om et år.',
  'pkn.fam.metricPerMonth': '{amount}/mnd',
  'pkn.fam.idea.keyTitle': 'Bli enige om fordelingsnøkkelen',
  'pkn.fam.idea.keyText': 'Fordelingen av felleskostnadene avviker mer enn 15 prosentpoeng fra inntektsandelen. Mange velger enten lik deling eller deling etter inntekt — det viktigste er at dere har valgt bevisst.',
  'pkn.fam.metricDeviation': '{pp} pp avvik',
  'pkn.fam.idea.reviewTitle': 'Gå gjennom felleskostnadene sammen',
  'pkn.fam.idea.reviewText': 'Dere betaler {monthly} i felleskostnader hver måned, altså {yearly} i året. Sett av en kveld til å gå gjennom abonnementer, forsikringer og strømavtale samlet — det er der de fleste finner mest.',
  'pkn.fam.metricPerYear': '{amount}/år',
  'pkn.fam.ideasEmpty': 'Når dere har lagt inn inntekt og felleskostnader, foreslår jeg konkrete grep dere kan ta sammen.',
  'pkn.fam.editPerson': 'Rediger person',
  'pkn.fam.addPerson': 'Legg til person',
  'pkn.fam.goToMyPage': 'Gå til Min side',
  'pkn.fam.devMode': 'Utviklingsmodus: Du er ikke koblet til en partner ennå. Data du registrerer her forblir i din egen Privatøkonomi-klient. Koble sammen to separate kontoer på Min side for å dele Familie-profilen.',
  'pkn.fam.askSuperPlumma': 'Spør SuperPlumma',
  'pkn.fam.connectedEmpty': 'Dere er koblet sammen. Legg inn opplysninger dere ønsker å dele for å sammenligne inntektsandel og andel av felleskostnadene.',
  'pkn.fam.subShared': 'Delt mellom de tilkoblede Privatøkonomi-kontoene',
  'pkn.fam.subLocal': 'Lokal utviklingsvisning · ikke delt',
  'pkn.fam.cardSub': 'felleskostnader / mnd · inntekt {income}',
  'pkn.fam.cardShares': '{income} % av inntekt · {costs} % av felleskostnader',
  'pkn.fam.householdSuffix': 'i felleskostnader per måned. Sammenlign kostnadsandelen med inntektsandelen for å vurdere fordelingen.',
  'pkn.for.tone.over': 'Over budsjett',
  'pkn.for.tone.near': 'Nærmer seg',
  'pkn.for.tone.within': 'Innenfor',
  'pkn.for.noImportedMonth': 'Ingen importerte transaksjoner denne måneden',
  'pkn.for.plannedIncome': 'Planlagt inntekt',
  'pkn.for.incomeHint': 'Bruk brutto lønn og skatteprosent når du vet avtalt lønn. Netto er det du forventer inn på konto.',
  'pkn.for.grossPerMonth': 'Brutto per måned',
  'pkn.for.netToAccount': 'Netto inn på konto',
  'pkn.for.limitHint': 'Grensen settes per hovedkategori. Egne kategorier under legges til i tillegg.',
  'pkn.for.used': 'brukt {amount}',
  'pkn.for.showAsGroup': 'Vis som egen hovedkategori i «Hvor pengene går»',
  'pkn.for.budgetUpdated': 'Budsjettet er oppdatert',
  'pkn.for.gross': '{amount} brutto',
  'pkn.for.taxPct': '{pct} % skatt',
  'pkn.for.netPerMonth': 'Netto per måned',
  'pkn.for.budgetUses': 'budsjett bruker {pct} %',
  'pkn.for.noBudgets': 'Du har ikke satt budsjett for noen kategorier ennå. Trykk «Juster budsjett» for å sette en månedlig grense — så følger jeg med og sier fra når en kategori nærmer seg.',
  'pkn.for.budgetedInPeriod': 'budsjettert i perioden',
  'pkn.for.leftInPeriod': '{amount} igjen i perioden',
  'pkn.for.overBudget': '{amount} over budsjett',
  'pkn.for.allWithin': 'Alle kategorier innenfor',
  'pkn.for.overLimitOne': '{count} kategori over grensen',
  'pkn.for.overLimitMany': '{count} kategorier over grensen',
  'pkn.for.pctUsed': '{pct} % brukt',
  'pkn.for.diffLeft': '{amount} igjen',
  'pkn.for.diffOver': '{amount} over',
  'pkn.for.mainCategories': 'Hovedkategorier',
  'pkn.for.allCategories': 'Alle kategorier',
  'pkn.for.noSpendInPeriod': 'Ingen registrert forbruk i {period}. Velg en annen periode, eller last opp kontoutskriften for denne måneden under Import.',
  'pkn.for.noSpendData': 'Ingen forbruksdata ennå. Last opp en kontoutskrift under Import, så leser jeg av transaksjonene og kategoriserer dem automatisk.',
  'pkn.for.highlight': 'Fremhev {name} i diagrammet',
  'pkn.for.hideCats': 'Skjul kategoriene i {name}',
  'pkn.for.showCats': 'Vis kategoriene i {name}',
  'pkn.for.seeTx': 'Se transaksjoner i {name}',
  'pkn.for.ofGroupSuffix': '% av gruppen',
  'pkn.for.biggest': 'Største {kind} er',
  'pkn.for.kindCost': 'kostnadskategori',
  'pkn.for.kindMain': 'hovedkategori',
  'pkn.for.biggestSuffix': 'med {amount} — {pct} % av forbruket i perioden.',
  'pkn.for.noRecurring': 'Jeg har ikke funnet gjentakende abonnementstrekk ennå. Når flere måneder med kontoutskrifter er lest inn, lister jeg opp faste trekk med beregnet årlig kostnad. Du avgjør selv om tjenesten fortsatt er nyttig.',
  'pkn.for.recurringTotal': 'Gjentakende trekk i valgt periode utgjør omtrent {amount} i året.',
  'pkn.for.annualNote': 'Dette er årlig kostnad, ikke en lovet besparelse. Kontroller hvert trekk før du endrer noe.',
  'pkn.for.confidence': 'Sikkerhet {pct} %',
  'pkn.for.showTx': 'Vis transaksjoner',
  'pkn.for.yesSubscription': 'Ja, abonnement',
  'pkn.for.iUseIt': 'Jeg bruker det',
  'pkn.for.iWantToCancel': 'Jeg vil avslutte',
  'pkn.for.remindLater': 'Minn meg senere',
  'pkn.fut.notSet': 'ikke satt',
  'pkn.fut.notBeforeRetirement': 'ikke før pensjon',
  'pkn.fut.status.reached': 'Nådd',
  'pkn.fut.status.planned': 'Planlagt',
  'pkn.fut.status.noSaving': 'Mangler sparebeløp',
  'pkn.fut.factor.progress': 'Fremdrift mot mål',
  'pkn.fut.factor.progressNote': '{pct} % av samlet målbeløp er spart',
  'pkn.fut.factor.onPlan': 'Mål på plan',
  'pkn.fut.factor.onPlanNote': '{count} av {total} mål i god rute',
  'pkn.fut.factor.autoBalance': 'Automatisk saldo',
  'pkn.fut.factor.autoBalanceNote': '{count} av {total} mål er koblet til konto',
  'pkn.fut.life.goalReached': '{name} nådd',
  'pkn.fut.life.netWorthPasses': 'Nettoformue passerer {amount}',
  'pkn.fut.life.retireAge': 'Pensjonsalder {age} år',
  'pkn.fut.impact.netWorth5': 'Nettoformue om 5 år',
  'pkn.fut.impact.retireAge': 'Pensjonsalder',
  'pkn.fut.ageYears': '{age} år',
  'pkn.fut.impact.savingToGoals': 'Sparing til mål',
  'pkn.fut.perMonth': '{amount}/mnd',
  'pkn.fut.xOfY': '{count} av {total}',
  'pkn.fut.impact.debt': 'Gjeld',
  'pkn.fut.unchanged': 'Uendret',
  'pkn.fut.goalSaved': 'Målet er lagret',
  'pkn.fut.eventSaved': 'Livshendelsen er lagret',
  'pkn.fut.enterAssumptions': 'Legg inn dine egne forutsetninger før Plumme lager prognoser.',
  'pkn.fut.noForecast': 'Vi viser ikke en personlig prognose basert på standardalder, standardavkastning eller antatt pensjonsalder. Opprett planen med dine egne tall først.',
  'pkn.fut.createPlan': 'Opprett fremtidsplan',
  'pkn.fut.horizon1': '1 år',
  'pkn.fut.horizon5': '5 år',
  'pkn.fut.horizon10': '10 år',
  'pkn.fut.horizonRetirement': 'Pensjon',
  'pkn.fut.reaches': 'nås',
  'pkn.fut.expectedAtRetirement': 'Forventet formue ved pensjon ({age} år):',
  'pkn.fut.forMonths': 'i {count} mnd',
  'pkn.fut.permanent': 'varig',
  'pkn.fut.oneOff': '{amount} engang',
  'pkn.fut.incoming': '{amount} inn',
  'pkn.fut.switchOn': 'Slå på',
  'pkn.fut.switchOff': 'Slå av',
  'pkn.fut.eventRemoved': 'Livshendelsen er fjernet',
  'pkn.fut.goalsOnTrackSuffix': 'mål i rute · {pct} % samlet fremdrift',
  'pkn.fut.first': 'først',
  'pkn.fut.priorityBody': 'Dette målet trenger mest oppfølging i planen. Det mangler {amount}.',
  'pkn.fut.targetDate': 'Med dagens plan er beregnet måldato {date}.',
  'pkn.fut.cannotCalcEnd': 'Kan ikke beregne sluttdato med dagens sparebeløp',
  'pkn.fut.noGoals': 'Du har ingen mål ennå. Legg til ditt første — buffer, egenkapital, ferie eller noe annet — så regner jeg ut når du er i mål og hva som får deg dit raskere.',
  'pkn.fut.planStatus': 'Planstatus',
  'pkn.fut.action1': 'Sett opp fast trekk på lønningsdagen',
  'pkn.fut.action2': 'Øk den månedlige sparingen litt',
  'pkn.fut.action3': 'Flytt et engangsbeløp hit',
  'pkn.fut.reachesGoal': '{name} når målet',
  'pkn.fut.amountLeft': '{amount} igjen',
  'pkn.fut.courseA': 'Dette er kursen økonomien din ligger på med planen du har lagt inn',
  'pkn.fut.courseB': 'Hver lille justering — litt mer sparing, en refinansiering, et kuttet abonnement — flytter hele tidslinjen nærmere.',
  'pkn.fut.goalDeleted': 'Målet er slettet',
  'pkn.fut.deleteGoalBody': 'Fremdriften på {amount} forsvinner fra oversikten, og målet fjernes fra prognosen og livsplanen din.',
  'pkn.fut.familyIntro': 'Familieøkonomi viser hvem i husholdningen som betaler hva, hvordan dere ligger an mot hverandre, og hvor rettferdig fordelingen er mot inntekt. For å regne det ut trenger jeg husholdningsmedlemmer og eierskap på transaksjonene — det kobles på i et senere steg.',
  'pkn.fut.noMembers': 'Ingen husholdningsmedlemmer er registrert ennå. Når husholdningen er satt opp og transaksjonene har eierskap, viser jeg kostnadene per person, sammenligner forbruket kategori for kategori og regner ut hvor rettferdig fordelingen av felleskostnadene er.',
  'pkn.fut.personalSpend': 'Personlig forbruk · deg vs. partner',
  'pkn.fut.splitOne': 'i måneden fordelt på {count} person.',
  'pkn.fut.splitMany': 'i måneden fordelt på {count} personer.',
  'pkn.gj.icon.card': 'Kort/forbruk',
  'pkn.gj.icon.home': 'Bolig',
  'pkn.gj.icon.car': 'Bil',
  'pkn.gj.icon.bank': 'Bank/studie',
  'pkn.gj.never': 'Aldri',
  'pkn.gj.monthsShort': '{count} mnd',
  'pkn.gj.yearsShort': '{count} år',
  'pkn.gj.health.expensiveLabel': 'Dyr gjeld',
  'pkn.gj.health.expensiveNote': 'Rente over 12 % — sjekk refinansiering',
  'pkn.gj.health.highLabel': 'Høy rente',
  'pkn.gj.health.highNote': 'Rente over 8 %',
  'pkn.gj.health.lowLabel': 'Lav rente',
  'pkn.gj.health.lowNote': 'Rimelig gjeld',
  'pkn.gj.health.okLabel': 'Grei rente',
  'pkn.gj.health.okNote': 'Vanlig rentenivå',
  'pkn.gj.journey.paidOff': '{name} nedbetalt',
  'pkn.gj.journey.half': 'Halvparten av {name} nedbetalt',
});
